import React from 'react';

interface FontAwesomeIconProps {
  className: string;
}

const FontAwesomeIcon: React.FC<FontAwesomeIconProps> = ({ className }) => <i className={`fa ${className}`} aria-hidden="true" />;

export default FontAwesomeIcon;
